export const ALL_DEPOSIT_POST_REQUEST = "ALL_DEPOSIT_POST_REQUEST"
export const ALL_DEPOSIT_POST_SUCCESS = "ALL_DEPOSIT_POST_SUCCESS"
export const ALL_DEPOSIT_POST_FAIL = "ALL_DEPOSIT_POST_FAIL"

export const ALL_DEPOSIT_GET_REQUEST = "ALL_DEPOSIT_GET_REQUEST"
export const ALL_DEPOSIT_GET_SUCCESS = "ALL_DEPOSIT_GET_SUCCESS"
export const ALL_DEPOSIT_GET_FAIL = "ALL_DEPOSIT_GET_FAIL"

export const CLEAR_ERRORS = "CLEAR_ERRORS"